import { ActionWrapper } from 'components/ActionItem';
import { localizable } from 'components/Localization';
import { computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { RoundItem } from './Rounds';
import sale from '../stores/SaleStore';

const excludedRoundTypes = ['registration', 'counteroffer'];

@inject('app', 'sale')
@localizable
class RoundSelector extends Component {
  @observable openRoundWarning = false;

  @computed get rounds() {
    const { sale } = this.props;

    if (!!sale.features && sale.features.isMasterSale) return ['registration'];
    return sale.saleConfig.roundTypes.filter(
      (round) => !excludedRoundTypes.includes(round)
    );
  }

  render() {
    const { className, handleSelect, theme } = this.props;
    return (
      <ActionWrapper className={className + ' clearfix'}>
        {this.rounds &&
          this.rounds.map((round) => {
            return (
              <RoundItem
                {...{ handleSelect, theme, round }}
                key={round}
                badges={(sale.saleConfig.roundTypeBadges || {})[round]}
                costHighlight={
                  (sale.saleConfig.roundCostHighlight || {})[round]
                }
              />
            );
          })}
      </ActionWrapper>
    );
  }
}

export default observer(RoundSelector);



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Guides/RoundSelector.jsx